import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OrdersModel, SendOrderParameters, GetBrandOrderSettingsResponse } from 'models';
import { Price } from 'services';

import { GtinMap } from 'types';
import { ReorderPrepackProduct } from 'app/b2b-order/types/reorder';

@Injectable()
export class OrderService {
    constructor(private ordersModel: OrdersModel) {}

    public createOrder(orderData: SendOrderParameters) {
        return this.ordersModel.send(orderData);
    }

    public getBrandOrderSettings(brandIds: string[]): Observable<GetBrandOrderSettingsResponse[]> {
        return this.ordersModel.getBrandOrderSettings(brandIds);
    }

    public noArticleSelectedForOrder(orderArticles: OrderArticle[]): boolean {
        return _.every(
            orderArticles,
            (orderArticle: OrderArticle) =>
                _.every(orderArticle.sizes, (size: OrderArticleSize) => size.amount === 0) &&
                _.every(orderArticle.prepacks, (prepack: OrderArticlePrepack) => prepack.amount === 0)
        );
    }
}

export interface OrderArticle {
    color: OrderArticleColor;
    sizes: OrderArticleSize[];
    brandId: string;
    styleGroupId: string;
    imageUrl: string;
    discountedPurchasePrice?: number;
    purchasePrice?: number;
    recommendedRetailPrice?: number;
    currency?: string;
    prepacks?: OrderArticlePrepack[];
}

export interface OrderArticlePrepack {
    _id: string;
    externalId: string;
    stock: number;
    products: ReorderPrepackProduct[];
    colorGroupId: string;
    amount: number;
}

export interface OrderArticleSize {
    name: string;
    gtin: string;
    stock: number;
    amount: number;
    price?: Price;
}

interface OrderArticleColor {
    name: string;
    code: string;
    colorGroupId: string;
}

export interface FormattedPrepack {
    _id: string;
    externalId: string;
    stock: number;
    products: GtinMap<Omit<ReorderPrepackProduct, 'gtin'>>;
    colorGroupId: string;
    amount: number;
}
